import { ElementRef, OnDestroy, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { PageMetadataRegistry, } from '@app/router';
import { filterNullOrUndefined } from '@utils/rxjs.utils';
import { combineLatest, Subject, } from 'rxjs';
import { map, takeUntil, tap, } from 'rxjs/operators';
import { HeaderOverrideService } from './header-override.service';
var UiTopNavigationComponent = /** @class */ (function () {
    function UiTopNavigationComponent(headerOverride, _pageRegistry, _appState, route) {
        var _this = this;
        this.headerOverride = headerOverride;
        this._pageRegistry = _pageRegistry;
        this._appState = _appState;
        this.activePage$ = this._pageRegistry.activePage$;
        this._destroyed$ = new Subject();
        this.isActive = function (page) {
            return _this._pageRegistry.isActivePage(page);
        };
        this._determineHeaderItems = function (page) {
            var searchTitle = page.hasParent
                ? page.parent.title
                : page.title;
            var children = page.type === 'Breadcrumb'
                ? [page]
                : _this._pageRegistry.pages
                    .filter(function (p) {
                    return (!p.featureFlag || _this._appState.settings.isFeatureEnabled(p.featureFlag)) &&
                        p.type === 'SubMenu' &&
                        p.parent &&
                        p.parent.title === searchTitle;
                });
            var main = page.parent || page;
            return [main].concat(children);
        };
        var page$ = this._pageRegistry
            .activePage$
            .pipe(tap(function () { return _this.focusPageAriaTitle(); }));
        this.items$ = combineLatest([
            page$,
            route.queryParamMap,
        ]).pipe(map(function (_a) {
            var page = _a[0], queryParamMap = _a[1];
            return _pageRegistry.find(queryParamMap.get('target')) || page;
        }), filterNullOrUndefined(), map(this._determineHeaderItems), takeUntil(this._destroyed$));
    }
    Object.defineProperty(UiTopNavigationComponent.prototype, "currentLink", {
        get: function () {
            return this._pageRegistry.cleanCurrentUrl;
        },
        enumerable: true,
        configurable: true
    });
    UiTopNavigationComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    UiTopNavigationComponent.prototype.focusPageAriaTitle = function () {
        if (this.pageAriaTitle) {
            this.pageAriaTitle.nativeElement.focus();
        }
    };
    return UiTopNavigationComponent;
}());
export { UiTopNavigationComponent };
